import {
  ACCOUNT_COMMITTEE,
  ACCOUNT_HOUSE_SPEAKER,
  ACCOUNT_SUPER_ADMIN,
  SUPER_ADMIN_ACCOUNTS,
} from "utility/constants";

import { ALLOCATION_STATUS } from "constants/status";

export const NO_AFFILIATED_AGENCIES_ACCOUNTS = [
  ACCOUNT_COMMITTEE,
  ...SUPER_ADMIN_ACCOUNTS,
  ACCOUNT_HOUSE_SPEAKER,
];

export const RESEND_STATUSES = [
  ALLOCATION_STATUS.APPROVED,
  ALLOCATION_STATUS.PENDING,
];

export const resendOptions = [
  {
    id: 1,
    label: "General",
    value: "general",
  },
  {
    id: 2,
    label: "Approval",
    value: "approval",
  },
];

export const resendIconStatus = [
  ALLOCATION_STATUS.APPROVED,
  ALLOCATION_STATUS.DOWNLOADED,
  ALLOCATION_STATUS.PROCESSED,
];

export const checkboxPromptForEndorsingAllocations = (
  oldValue,
  newValue,
  role
) => {
  const html = `
    <p style="text-align: center; margin-bottom: 1rem;">
      Are you sure you want to change the status from ${oldValue} 
      to ${newValue}?
    </p>
    <div style="text-align: center; margin-top: 1rem;">
      ${
        role !== ACCOUNT_HOUSE_SPEAKER
          ? `
      <label style="align-items: center;">
        <input type="checkbox" id="swal-checkbox2" 
          style="margin-right: 0.5rem;">
        <span>
          Show this endorsement to House Speaker 
          HON. FAUSTINO 'Bojie' D. DY III?
        </span>
      </label>`
          : ""
      }
      ${
        role === ACCOUNT_SUPER_ADMIN
          ? `
      <label style="align-items: center; margin-top: 1rem;">
        <input type="checkbox" id="swal-checkbox3" checked
          style="margin-right: 0.5rem;">
        <span>
          Do not send SMS notifications to Directors, Editors, and Agencies.
        </span>
      </label>`
          : ""
      }
    </div>
  `;

  return html;
};

export const acceptedFileTypes = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/pdf",
];

export const selectorOptions = [
  {
    value: 1,
    label: "Senator",
  },
  {
    value: 2,
    label: "Governor",
  },
  {
    value: 3,
    label: "Vice Governor",
  },
  {
    value: 4,
    label: "Mayor",
  },
  {
    value: 5,
    label: "Vice Mayor",
  },
  {
    value: 6,
    label: "Others",
  },
];
